<template>

  <div>
  
    <!-- <transition name="fade">
      <router-view></router-view>
    </transition> -->

 <transition name="fade">
      <div class="fh cc">
        <div class="fh cc">
            <div class="menu-mobile" :class="{'menu-mobile-expand': showMenu}">
                <div class="fv ct" style="width: 100%; ">
                    <div class="fv cc" style="width: 100%; margin-top: 20px">
                        <img style="width: 40%" src="/dist/logo_menu2.png"  />
                    </div>
                    <div class="fv cc" style="width: 100%; height: 60px; color: white; font-size: 18px; 
                                              font-weight: 500;">
                         {{nombreUsuario}}
                    </div>
                    <div class="fh lc" style="width: 100%; height: 30px;" @click="cambiarPass">
                        <div class="fv lc" style="width: 90%; height: 100%; margin-left: 20px; color: white;
                                                  font-size: 10px">
                            Cambiar Contraseña
                        </div>
                        <div class="fv lc" style="width: 10%; height: 100%">
                            <img style="width: 15px; height: 15px; margin-right: 10px" src="/dist/icon_right_white.png"  />
                        </div>
                    </div> 
                    <div class="fh lc" style="width: 100%; height: 30px;" @click="cerrarSesion">
                        <div class="fv lc" style="width: 90%; height: 100%; margin-left: 20px; color: white;
                                                  font-size: 10px">
                            Cerrar Sesion
                        </div>
                        <div class="fv lc" style="width: 10%; height: 100%">
                            <img style="width: 15px; height: 15px; margin-right: 10px" src="/dist/icon_right_white.png"  />
                        </div>
                    </div> 
                    <div class="fv cc" style="width: 90%; height: 1px; background: #bbbbbb; margin-top: 10px"></div>
                    <div class="fv lb" v-show="showSeccionCliente" style="width: 100%; height: 40px; color: white; font-size: 18px; 
                                              font-weight: 500; margin-left: 40px">
                        Cliente
                    </div>
                    <div class="fh lc" v-show="showSeccionCliente" style="width: 100%; height: 30px;" @click= "btnCliente">
                        <div class="fv lc" style="width: 90%; height: 100%; margin-left: 20px; color: white;
                                                  font-size: 10px">
                            {{nombreCliente}}
                        </div>
                        <div class="fv lc" style="width: 10%; height: 100%">
                            <img style="width: 15px; height: 15px; margin-right: 10px" src="/dist/icon_right_white.png"  />
                        </div>
                    </div> 
                    <div class="fv cc" v-show="showSeccionCliente" style="width: 90%; height: 1px; background: #bbbbbb; margin-top: 10px"></div>
                </div>
            </div>
        </div>
        <div class="fh cc">
            <router-view>
            </router-view>
        </div>
      </div>
    </transition>

    <transition name="fadePro">
        <div id="myModal" class="modal" v-show='showProgress' @click="closePopup">
          <div></div> 
          <div class="modal-content">
           <div class="loader"> </div>
          </div>
        </div> 
    </transition>  

    <transition name="fadePopup">
      <div id="myModalPopup"  v-show='popupVisible' @click='clickOut' >
        <div id='back-popup'style="z-index: 10">
        </div> 
        <div class="modal-content-mainpopup" style="z-index: 10">
          <div id='textoContainer-mainpopup'>
            <p id='texto-mainpopup'>{{popupTxt}}</p>
          </div> 
          <div id='btnContainer-mainpopup'>
            <button id='mainpopupBtn1' @click='btnCancel' v-show='popupTxtBtnCancelVisible'>{{popupTxtBtnCancel}}</button>
            <button id='mainpopupBtn2' @click='btnOk'>{{popupTxtBtnOk}}</button>
          </div>
        </div>
      </div> 
    </transition>  

  </div>

</template>

<script>
import '@assets/sheets/main.css'
import 'picasso.css/dist/build.min.css'
import axios from 'axios'

export default {
  name: 'App',


  computed: {

    showMenu () {
      return this.$store.state.popup.popupMenu;
    },

    showProgress () {
      return this.$store.state.loader.visible;
    },

    nombreUsuario() 
    {
      if (this.$store.state.user.usuario != null)
      {
        if (this.$store.state.user.usuario.EsEmpleado)
        {
            return this.$store.state.user.usuario.EmpleadoNombre;
        } 
        else
        {
            return this.$store.state.user.usuario.ClienteNombre;
        }  
      }
      else   
      {
         return '' 
      }
    },

    nombreCliente() 
    {
      if (this.$store.state.user.usuario != null)
      {
        if ((this.$store.state.user.usuario.EsEmpleado) && (this.$store.state.user.cliente != null))
        {
            return this.$store.state.user.cliente.Nombre;  
        } 
        else
        {
            return "";
        }  
      }
      else 
      {
        return '';
      }
    },

    showSeccionCliente() 
    {
      if (this.$store.state.user.usuario != null)
      {
        if ((this.$store.state.user.usuario.EsEmpleado) && (this.$store.state.user.cliente != null))
        {
            return true
        } 
        else
        {
            return false
        }  
      }
      else 
      {
        return false;
      }
    },

    popupVisible () {
      return this.$store.state.popup.popupVisible
    },

    popupTxt () {
      return this.$store.state.popup.texto
    },

    popupTxtBtnCancel () {
      return this.$store.state.popup.txtBtnCancel
    },

    popupTxtBtnOk () {
      return this.$store.state.popup.txtBtnOk
    },

    popupTxtBtnCancelVisible () {
      if (this.$store.state.popup.txtBtnCancel == '')
      {
        return false
      }
      else
      {
        return true
      }
    }
  
  },


  methods: 
  {

    cambiarPass() {
      this.$router.push({ name: "configuracion" });
      this.$store.commit('popup/closeMenu');
      this.iconMenu = '/dist/icon-menu.png';
    },
    
    cerrarSesion() {
        this.$store.commit("loader/start");
        axios.put('/WebSalesLogin',{},{
         headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
         }
        ).then((response) => {
           this.$store.commit('popup/closeMenu');
           this.iconMenu = '/dist/icon-menu.png';
           this.$store.commit("loader/stop");
           this.$access('any')
           this.$store.commit('user/deleteUser');
           this.$store.commit('user/deleteCliente');
           this.$store.commit('user/deleteEmpresas');
           this.$store.commit('user/deleteResponseLogin');
           this.$store.commit('user/deleteImagenLogo');
           this.$store.commit('user/deleteImagenHeader');
           this.$store.commit('pedido/delete');
           this.$store.commit('entorno/delete');
           this.$router.push({ name: "login" });
           if (response.data.Code != 0)
           {
             alert(response.data.Message);
           }

        },(error) => { console.log(error)
            alert(error);  })
    },


    btnCliente() {
      this.$router.push({ name: "clientes" });
      this.$store.commit('popup/closeMenu');
      this.iconMenu = '/dist/icon-menu.png';
    },


    btnCancel (){
      this.$store.commit('popup/btnCancel');
    },
    btnOk (){
      this.$store.commit('popup/btnOk');
    },
    clickOut (){
      this.$store.commit('popup/close');
    },
    closePopup() {
      this.$store.commit("loader/stop");
    }
  },



}




</script>

<style>

*{
  margin:  0;
  padding: 0;
}




.menu-mobile {
   position: fixed; 
   top: 40px; 
   display: flex;
   flex-direction: column; 
   /* justify-content: center;    
   align-items: center;  */
   width: 230px;
   height:100vh;
   transform: translateX(-100%);
   background:#005A9F;
   overflow: hidden;
   transition: transform 0.5s;
   z-index: 99;
}


.menu-mobile-expand {
   position: fixed; 
   top: 40px; 
   display: flex;
   flex-direction: column; 
   /* justify-content: center;    
   align-items: center;  */
   width: 230px;
   height:100vh;
   transform: translateX(50%);
   background:#005A9F;
   overflow: hidden;
   transition: transform 0.5s;
   z-index: 99;
}



.datepicker-ic{
  background-color: #ffffff;
  border: none;
  height: 28px;
  width: 335px;
  }

.datepicker-ic-mobile{
  background-color: #ffffff;
  border: none;
  height: 28px;
  width: 200px;
  }




#back-popup {
 position: absolute;
 top: 0;
 left: 0;
 width: 100%;
 height: 100vh;
 background: #000000;
 opacity: 0.5;  
}



.modal-content-mainpopup {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 300px;
border-radius:15px; 
background-color: #ffffff;
display: flex;    
flex-direction: column; 
align-items: center; 
}



#textoContainer-mainpopup {
background: #ffffff;
width: 90%;
padding-top: 25px;
padding-bottom: 10px;
display: flex;    
flex-direction: row; 
justify-content: center; 
}


#texto-mainpopup {
font-size: 16px;
color: #000000;
text-align: center;
}


#btnContainer-mainpopup {
 width: 90%;
 height: 65px;
 background: #ffffff;  
 display: flex;    
 flex-direction: row; 
 justify-content: center; 
 align-items: center; 
}


#mainpopupBtn1 {
  margin-right: 5px;
  height: 30px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
  text-align: center;
  height: 30px;
  color: #5c666f;
  background: #ffffff; 
  border-width: 1px;
  border: 2px solid #5c666f;
  outline: none;
}


#mainpopupBtn2 {
  /*width: 100%;*/
  margin-left: 5px;
  height: 30px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
  text-align: center;
  /*width: 80px;*/
  background: #005A9F; 
  color: #ffffff;
  border-width: 1px;
  border: 2px solid #005A9F;
  outline: none;
}

#mainpopupBtn1:hover { cursor: pointer; }
#mainpopupBtn2:hover { cursor: pointer; }

.modal {
 position: absolute;
 top: 0;
 left: 0;
 width: 100%;
 height: 100vh;
 background: #000000;
 opacity: 0.5;  
}

/* Modal Content */
.modal-content {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 100px;
height: 100px;
background-color: #000000;
display: flex;    
justify-content: center; 
align-items: center; 
}


.loader {
  border: 8px solid #f3f3f3;
  border-radius: 100%;
  border-top: 8px solid #3498db;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0}




.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 0.5;
}
.fadePro-leave {
  opacity: 0.5;
}
.fadePro-leave-active {
  transition: opacity 0.5s;
}
.fadePro-leave-to {
  opacity: 0;
}


.fadePopup-enter {
  opacity: 0;
}
.fadePopup-enter-active {
  transition: opacity 0.5s;
}
.fadePopup-enter-to {
  opacity: 1;
}
.fadePopup-leave {
  opacity: 1;
}
.fadePopup-leave-active {
  transition: opacity 0s;
}
.fadePopup-leave-to {
  opacity: 0;
}

</style>




// WEBPACK FOOTER //
// src/app.vue